import type { LocaleKey } from "./index";
import {
  BUSINESS_TYPES as EN_US_BUSINESS_TYPES,
  ROLES as EN_US_ROLES,
  SALUTATIONS as EN_US_SALUTATIONS,
} from "./langs/en-US";
import {
  BUSINESS_TYPES as EN_GB_BUSINESS_TYPES,
  ROLES as EN_GB_ROLES,
  SALUTATIONS as EN_GB_SALUTATIONS,
} from "./langs/en-GB";
import {
  BUSINESS_TYPES as FR_FR_BUSINESS_TYPES,
  ROLES as FR_FR_ROLES,
  SALUTATIONS as FR_FR_SALUTATIONS,
} from "./langs/fr-FR";
import {
  BUSINESS_TYPES as DE_DE_BUSINESS_TYPES,
  ROLES as DE_DE_ROLES,
  SALUTATIONS as DE_DE_SALUTATIONS,
} from "./langs/de-DE";
import {
  BUSINESS_TYPES as ES_ES_BUSINESS_TYPES,
  ROLES as ES_ES_ROLES,
  SALUTATIONS as ES_ES_SALUTATIONS,
} from "./langs/es-ES";
import {
  BUSINESS_TYPES as IT_IT_BUSINESS_TYPES,
  ROLES as IT_IT_ROLES,
  SALUTATIONS as IT_IT_SALUTATIONS,
} from "./langs/it-IT";
import {
  BUSINESS_TYPES as JP_JP_BUSINESS_TYPES,
  ROLES as JP_JP_ROLES,
  SALUTATIONS as JP_JP_SALUTATIONS,
} from "./langs/jp-JP";
import {
  BUSINESS_TYPES as NL_NL_BUSINESS_TYPES,
  ROLES as NL_NL_ROLES,
  SALUTATIONS as NL_NL_SALUTATIONS,
} from "./langs/nl-NL";
import {
  BUSINESS_TYPES as PT_BR_BUSINESS_TYPES,
  ROLES as PT_BR_ROLES,
  SALUTATIONS as PT_BR_SALUTATIONS,
} from "./langs/pt-BR";
import {
  BUSINESS_TYPES as PT_PT_BUSINESS_TYPES,
  ROLES as PT_PT_ROLES,
  SALUTATIONS as PT_PT_SALUTATIONS,
} from "./langs/pt-PT";

export type CdcOption = {
  id: string;
  label: string;
  value: string;
};

type OptionCollections = {
  businessTypes: ReadonlyArray<CdcOption>;
  roles: ReadonlyArray<CdcOption>;
  salutations: ReadonlyArray<CdcOption>;
};

const OPTIONS_BY_LOCALE: Record<LocaleKey, OptionCollections> = {
  "en-US": {
    businessTypes: EN_US_BUSINESS_TYPES,
    roles: EN_US_ROLES,
    salutations: EN_US_SALUTATIONS,
  },
  "en-GB": {
    businessTypes: EN_GB_BUSINESS_TYPES,
    roles: EN_GB_ROLES,
    salutations: EN_GB_SALUTATIONS,
  },
  "fr-FR": {
    businessTypes: FR_FR_BUSINESS_TYPES,
    roles: FR_FR_ROLES,
    salutations: FR_FR_SALUTATIONS,
  },
  "de-DE": {
    businessTypes: DE_DE_BUSINESS_TYPES,
    roles: DE_DE_ROLES,
    salutations: DE_DE_SALUTATIONS,
  },
  "es-ES": {
    businessTypes: ES_ES_BUSINESS_TYPES,
    roles: ES_ES_ROLES,
    salutations: ES_ES_SALUTATIONS,
  },
  "it-IT": {
    businessTypes: IT_IT_BUSINESS_TYPES,
    roles: IT_IT_ROLES,
    salutations: IT_IT_SALUTATIONS,
  },
  "jp-JP": {
    businessTypes: JP_JP_BUSINESS_TYPES,
    roles: JP_JP_ROLES,
    salutations: JP_JP_SALUTATIONS,
  },
  "nl-NL": {
    businessTypes: NL_NL_BUSINESS_TYPES,
    roles: NL_NL_ROLES,
    salutations: NL_NL_SALUTATIONS,
  },
  "pt-BR": {
    businessTypes: PT_BR_BUSINESS_TYPES,
    roles: PT_BR_ROLES,
    salutations: PT_BR_SALUTATIONS,
  },
  "pt-PT": {
    businessTypes: PT_PT_BUSINESS_TYPES,
    roles: PT_PT_ROLES,
    salutations: PT_PT_SALUTATIONS,
  },
} as const;

export function getCdcSalutationOptions(
  locale: LocaleKey,
): ReadonlyArray<CdcOption> {
  const options = OPTIONS_BY_LOCALE[locale]?.salutations;
  return options ?? OPTIONS_BY_LOCALE["en-US"].salutations;
}

export function getCdcRoleOptions(locale: LocaleKey): ReadonlyArray<CdcOption> {
  const options = OPTIONS_BY_LOCALE[locale]?.roles;
  return options ?? OPTIONS_BY_LOCALE["en-US"].roles;
}

export function getCdcBusinessTypeOptions(
  locale: LocaleKey,
): ReadonlyArray<CdcOption> {
  const options = OPTIONS_BY_LOCALE[locale]?.businessTypes;
  return options ?? OPTIONS_BY_LOCALE["en-US"].businessTypes;
}
